import { sphere } from '../scene/geo';

export function faceAngles(lat: number, lon: number) {
  const p = sphere(lat, lon).normalize();
  const r = Math.hypot(p.x, p.z);
  return { yaw: Math.atan2(-p.x, p.z), pitch: Math.atan2(p.y, r) };
}
